import { useEffect } from "react";
import { FLOW_STATE, exists, useSessionCtx, useSessionJWT, parsePaypalDetailsFromFlowState } from "utils";
import { getPaymentMethod } from "api/payments";

const completeWithPaymentMethod = async (pmId, onComplete, sessionJWT, debug) => {
  const { payload: paymentMethod } = await getPaymentMethod(sessionJWT, pmId);
  debug(`ADDPM__paymentMethod2: ${JSON.stringify(paymentMethod)}`);
  onComplete({
    state: FLOW_STATE.COMPLETE,
    id: paymentMethod.id,
    psp_reference: paymentMethod.psp_reference,
    pm_state: paymentMethod.pm_state,
  });
};

// interpret a paypal result in the flow state to indicate a fresh create and return it
const processPaypalResult = async (debug, flowState, onComplete, sessionJWT, setFlowState) => {
  debug("ADDPM__flowState: ", flowState);
  const paypalResult = parsePaypalDetailsFromFlowState(flowState);
  debug("ADDPM__paypalResult flowState: ", paypalResult);
  const { name, state, pmId } = paypalResult;

  if (name === "paypal") {
    if (state === FLOW_STATE.COMPLETE) {
      if (exists(pmId)) {
        setFlowState(); //clear the flow state
        completeWithPaymentMethod(pmId, onComplete, sessionJWT, debug);
      } else {
        debug("ADDPM__unknown flowState: ", paypalResult);
      }
    } else if (state === FLOW_STATE.CANCEL) {
      setFlowState(); //clear the flow state
      onComplete({ state: FLOW_STATE.CANCEL });
    }
  } else {
    debug("ADDPM__unknown flowState: ", paypalResult);
  }
};

export const usePaypalResponseHandler = (onComplete) => {
  const { sessionJWT } = useSessionJWT();
  const { debug, sessionCtx, setFlowState } = useSessionCtx();
  const { flowState } = sessionCtx;

  useEffect(() => {
    const process = async () =>
      await processPaypalResult(debug, flowState, onComplete, sessionJWT, setFlowState);
    if (exists(flowState)) {
      process();
    }
  }, [debug, flowState, setFlowState, onComplete, sessionJWT]);
};
